// extracted by mini-css-extract-plugin
export var radioInputRow = "t_rh";
export var radioInputColumn = "t_rj";
export var inputOptionRow = "t_qq";
export var inputOptionColumn = "t_qr";